
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <b>Marie-Theres B., 70, verstorben am 22. Oktober 2020</b>
    <br />
    <br />
    <i>Ihr Sohn sagt:</i>
    <br />
    <p>
  «Unsere Mutter war kerngesund. Dann wurden sie und ihr Lebenspartner, der zehn
  Jahre älter ist und Vorerkrankungen hat, angesteckt. Beide mussten ins Spital.
  Ein paar Tage später sogar in die Intensivpflege.
    </p>
    <p>
  Ihr Partner ist wieder gesund geworden, sie lag nach zehn Tagen im Sterben.
  Die ganze Intensivmedizin mitsamt einer Intubation hat nichts genützt. Die
  Ärzte sahen bald keine Hoffnung mehr und stellten die Maschinen ab.
    </p>
    <p>
  Wir verstehen das nicht. Beide waren im selben Boot – und sie stirbt, obwohl
  sie vor der Infektion bei guter Gesundheit war. Sie haben sich beide zuvor
  grosse Mühe gegeben, sich nicht anzustecken. Sie haben sich zurückgezogen und
  sich die Vorsichtsmassnahmen sehr zu Herzen genommen.
    </p>
    <p>
  Das hat uns gezeigt: Jeder kann ein Kandidat sein, wenn das Schicksal
  zuschlägt. Das Leben geht weiter.»
    </p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;